import React, {useEffect, useState} from "react";
import {Button, Card, Form, Input, message, Typography} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import {API_BASE_URL} from "../api/Settings";

const {Title, Paragraph} = Typography;

const NewPassword: React.FC = () => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const [token, setToken] = useState<string | null>(null);

    const [params] = useSearchParams();
    useEffect(() => {
        const tokenFromUrl = params.get('token');
        setToken(tokenFromUrl);
    }, [params]);

    const onFinish = (values: any) => {
        if (values.newPassword !== values.confirmPassword) {
            void message.error("Les mots de passe ne correspondent pas");
            return;
        }
        setLoading(true);
        // TODO: call API for password update

        fetch(`${API_BASE_URL}/users/reset-password`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                token: token,
                newPassword: values.newPassword,
            }),
        })
            .then(res => {
                if (!res.ok) throw new Error('Échec de la mise à jour du mot de passe');
                void message.success("Mot de passe mis à jour avec succès", 4);
                navigate('/');
                setLoading(false);
                return res.json();
            })
            .catch(err => {
                void message.error(`Erreur lors de la mise à jour du mot de passe : ${err.message}`);
                setLoading(false);
                return;
            });

        // setTimeout(() => {
        //     void message.success("Mot de passe mis à jour avec succès");
        //     setLoading(false);
        //     form.resetFields();
        // }, 1000);
    };

    const navigate = useNavigate();

    useEffect(() => {
        if (token === null) return; // attend que le token soit chargé

        if (!token) {
            void message.error('Token non fourni');
            navigate('/');
            return;
        }

        fetch(`${API_BASE_URL}/users/verify-reset-token`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({token}),
        })
            .then(res => {
                console.log('res', res);
                if (!res.ok) {
                    throw new Error(`Token invalide ou expiré`);
                }

                return res.json();
            })
            .then(data => {
                console.log('Token ok pour user ID:', data);
            })
            .catch((err) => {
                void message.error(`Ce lien de réinitialisation est invalide ou expiré`, 5);
                navigate('/');
            });
    }, [navigate, token]);

    return (
        <div style={{display: "flex", justifyContent: "center", padding: "2rem"}}>
            <Card style={{maxWidth: 400, width: "100%"}}>
                <Title level={3}>Réinitialisation du mot de passe</Title>
                <Paragraph>Veuillez entrer et confirmer votre nouveau mot de passe.</Paragraph>
                <Paragraph>{token}</Paragraph>

                <Form
                    form={form}
                    // layout="vertical"
                    onFinish={onFinish}
                    // label-col="{ span: 8 }"
                >
                    <Form.Item
                        label="Nouveau mot de passe"
                        labelCol={{span: 1}}
                        name="newPassword"
                        rules={[{required: true, message: "Veuillez saisir un mot de passe"}]}
                    >
                        <Input.Password placeholder="Nouveau mot de passe"/>
                    </Form.Item>

                    <Form.Item
                        label="Confirmez le mot de passe"
                        labelCol={{span: 1}}
                        name="confirmPassword"
                        rules={[{required: true, message: "Veuillez confirmer le mot de passe"}]}
                    >
                        <Input.Password placeholder="Confirmez le mot de passe"/>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Mettre à jour le mot de passe
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default NewPassword;
